import useImperativeNetworkRequest from '@root/core/src/hooks/use-imperative-network-request';
import { generateAndSendOtpConfiguration, verifyOtpConfiguration } from '@root/auth/src/api/mfa/mfa-request-configurations';

export default function useMfaRequests() {
  const [generateAndSendOtp] = useImperativeNetworkRequest(generateAndSendOtpConfiguration);
  const [verifyOtp] = useImperativeNetworkRequest(verifyOtpConfiguration);

  return {
    generateAndSendOtp,
    verifyOtp,
  };
}
